import React from 'react'
import ProductCards from '../../ProductCards'
import { useGetAllProductsQuery } from '../../../redux/APIs/productApi'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';


function SearchedProducts() {
  const location = useLocation();
  const dispatch = useDispatch();

  // Function to parse query parameters from the URL
  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    return Object.fromEntries(searchParams.entries());
  };

  console.log('QUERY', getQueryParams());


  const searchedProducts = useSelector((state) => state.product.searchedProducts);

  console.log('searchedProducts', searchedProducts);

  
  return (
    <div className='w-full px-12 py-12 flex flex-wrap gap-8 justify-center'>
      {searchedProducts?.results && searchedProducts?.results.map((product) => (
        <ProductCards product={product}/>
      ))}
    </div>
  )
}

export default SearchedProducts;